import { Component, OnInit, Inject, Optional, NgModule, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { POPOVER_DATA } from '../../popover/popover.service';
import { PopoverRef } from '../../popover/popover-ref';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
// import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'tt-layerinfo-popover',
    imports: [
      TranslateModule, MatButtonModule, MatIconModule
    ],
    templateUrl: './layerinfo-popover.component.html',
    styleUrls: ['./layerinfo-popover.component.css'],
    standalone: true
})

export class LayerinfoPopoverComponent {
    
  readonly translate = inject(TranslateService);
  private readonly popoverRef =  inject<PopoverRef<string>>(PopoverRef);
  readonly data = inject<any>(POPOVER_DATA, { optional: true });

  constructor(
    // public translate: TranslateService, 
    // private popoverRef: PopoverRef<string>,
    // @Optional() @Inject(POPOVER_DATA) public data?: any
  ) { }

  close(): void {
    this.popoverRef.close();
  }
}